import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SuperAdminService } from '../../../app/services/super-admin.service';
import { DialogAbstractComponent } from '../dialogs/dialog.class';

@Component({
  selector: 'app-kyc-video-player',
  templateUrl: './kyc-video-player.component.html',
  styleUrls: ['./kyc-video-player.component.scss'],
})
export class KycVideoPlayerComponent extends DialogAbstractComponent implements OnInit {
  @ViewChild('videoPlayer') videoplayer: any;
  videoInfo;
  src;
  constructor(injector: Injector, private superAdminService: SuperAdminService, private domSanitizer: DomSanitizer) {
    super(injector);
  }

  async ngOnInit() {
    // console.log(this.dialogParams);
    await this.loadVideo();
  }

  async loadVideo() {
    try {
      // let data = await this.superAdminService.getVideoUrl(this.dialogParams.kycVideoId);
      // this.videoInfo = data;
      this.src = 'http://' + this.videoInfo.pipeS3Link;
    } catch (e) {}
  }
}
